/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type ZerogDelegateTrxInfo = {
    TRXHA?: string;
    STAT?: ZerogDelegateTrxInfo.STAT;
    MTH?: string;
    BN?: string;
    AG?: string;
    FROM?: EvmAddressSummaryInfo;
    TO?: EvmAddressSummaryInfo;
    TRXF?: string;
    TRXFVAL?: string;
    VALADDR?: string;
    DELADDR?: string;
    DELAMT?: string;
    DELAMTVAL?: string;
    TS?: number;
    ACTTP?: ZerogDelegateTrxInfo.ACTTP;
};

export namespace ZerogDelegateTrxInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }

    export enum ACTTP {
        DELEGATION = 'DELEGATION',
        UNDELEGATION = 'UNDELEGATION',
    }


}

